import { render, staticRenderFns } from "./RgpDetails.vue?vue&type=template&id=cde87554&scoped=true&"
import script from "./RgpDetails.vue?vue&type=script&lang=js&"
export * from "./RgpDetails.vue?vue&type=script&lang=js&"
import style0 from "./RgpDetails.vue?vue&type=style&index=0&id=cde87554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde87554",
  null
  
)

export default component.exports